/* global $:false */

import LoginDialog from 'src/public/login_dialog'

export default class ClickRequiresLogin {
  static init () {
    Array.from($('.js-click-requires-login')).map((el) =>
      new ClickRequiresLogin(el))
  }

  constructor (el) {
    this.el = $(el)
    this.setupBindings()
  }

  setupBindings () {
    this.el.click(event => {
      if (window.gon && window.gon.logged_in) { return }

      event.preventDefault()
      event.stopPropagation()
      LoginDialog.show()
    })
  }
}
